import { InMemoryCache } from '@apollo/client/cache';

import { fieldPolicies, typePolicies, utils } from '@trqk/resolvers';

const { appSyncPagination } = utils;
const { audioUploads, session, uiState } = fieldPolicies;
const { UIState, PROTrack, bmatDetection } = typePolicies;

export const cache = new InMemoryCache({
    typePolicies: {
        RootQuery: {
            fields: {
                audioUploads,
                session,
                uiState,
                listTrqkAudios: appSyncPagination<TrqkAudio>(['filter']),
                listBmatDetections: appSyncPagination<BmatDetection>([
                    'filter',
                ]),
            },
            // It looks like there's a type bug in @apollo/client that requires casting this boolean
            // to `true | undefined`
            queryType: true as true | undefined,
        },
        UIState,
        PROTrack,
        bmatDetection,
    },
});
